import { useEffect, useRef } from 'react';
import { trackUsageEvent } from '../utils/usageAnalytics';

export default function useHomepageUsage(location) {
    const lastEntry = useRef(null);
    useEffect(() => {
        const entry = location.pathname + ':' + location.key;
        if (lastEntry.current === entry) return;
        lastEntry.current = entry;
        if (location.pathname === '/') void trackUsageEvent('homepage_view');
    }, [location.pathname, location.key]);
}
